import { render } from "./CssCustomization.vue?vue&type=template&id=0a34e0ba"
import script from "./CssCustomization.vue?vue&type=script&lang=js"
export * from "./CssCustomization.vue?vue&type=script&lang=js"

import "./CssCustomization.vue?vue&type=style&index=0&id=0a34e0ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__